module.exports = __webpack_public_path__ + "img/Droplii_logo-white.d9c335b3.png";